import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/layout/index.tsx";
import Home from "./components/layout/home/index.tsx";
import About from "./components/layout/about.tsx";
import Contact from "./components/layout/contact.tsx";
import Hosted from "./components/layout/hosted.tsx";
import DetailsHosted from "./components/layout/detailsHosted.tsx";
import SearchEvent from "./components/layout/searchEvent.tsx";
import DetailView from "./components/detail/index.tsx";
import Account from "./components/layout/account.tsx";
import BusinessVerification from "./components/layout/businessVerification.tsx";
import Tickets from "./components/my-tickets/tickets.tsx";
import Success from "./components/layout/success.tsx";
import Error from "./components/layout/error.tsx";
import Privacy from "./components/layout/privacy.tsx";
import Terms from "./components/layout/terms.tsx";
import ErrorPage from "./components/layout/ErrorPage.tsx";
import { TicketContext } from "./context/index.tsx";
function App() {
  const [checkLogin, setCheckLogin] = useState(false);
  const data = {
    checkLogin,
    setCheckLogin,
  };

  return (
    <TicketContext.Provider value={data}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="contact" element={<Contact />} />
            <Route path="hosted" element={<Hosted />} />
            <Route path="details-hosted/:eventId" element={<DetailsHosted />} />
            <Route path="discover" element={<SearchEvent />} />
            <Route path="account" element={<Account />} />
            <Route path="business-verification" element={<BusinessVerification />} />
            <Route path="tickets" element={<Tickets />} />
            <Route path="success" element={<Success />} />
            <Route path="privacy-policy" element={<Privacy />} />
            <Route path="terms-conditions" element={<Terms />} />
            <Route path="error" element={<Error />} />
            <Route path=":detailviewid" element={<DetailView />} />
            <Route path="*" element={<ErrorPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </TicketContext.Provider>
  );
}

export default App;
